import { useEffect, useState } from 'react';
import type { Connection } from '../../lib/connections-api';
export function liveState(c: Connection) {
  if (c.disconnected_at) return 'disconnected';
  if (!c.enabled) return 'off';
  if (c.state !== 'ready') return c.state;
  return c.endpoints.some(
    (e) =>
      e.status === 'ready' &&
      !!e.valid_until &&
      Date.parse(e.valid_until) > Date.now() &&
      c.capabilities.some(
        (cap) => cap.endpoint_id === e.id && cap.selected && cap.available,
      ),
  )
    ? 'ready'
    : 'checking';
}
export function useReadinessClock() {
  const [, setNow] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') setNow((v) => v + 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
}
